import React from 'react';
import { ModalBody, Spinner } from 'reactstrap';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { ReactComponent as InformationIcon } from 'assets/icon-information.svg';

import { colors } from 'shared/defaultTheme';

import { ModalHeader } from '../modal/ModalHeaders';
import { Button } from '../Buttons';

import { ConfirmModalWrapper, ConfirmMessage, ConfirmMessages } from './styles';

const ConfirmModal = ({
  className,
  isOpen,
  toggle,
  confirmMessage,
  confirmMessages,
  cancelText,
  okText,
  onCancel,
  onOk,
  isLoading,
  children,
}) => {
  const { mainColor } = useSelector((state) => state.theme);
  return (
    <ConfirmModalWrapper
      className={className}
      isOpen={isOpen}
      toggle={toggle}
      size={confirmMessages.length > 0 ? 'lg' : 'md'}
    >
      <ModalHeader
        className="modal-header"
        backgroundColor={colors.lightBlue}
        iconTitle={<InformationIcon className="icon-title" />}
        onClose={toggle}
      />
      <ModalBody>
        {confirmMessage !== '' && (
          <div className="w-100 d-flex flex-row justify-content-center mt-3">
            <ConfirmMessage>{confirmMessage}</ConfirmMessage>{' '}
          </div>
        )}
        {confirmMessages.length > 0 && (
          <div className="w-100 d-flex flex-column justify-content-center mt-3">
            {confirmMessages.map((message, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <ConfirmMessages key={i}>{message}</ConfirmMessages>
            ))}
          </div>
        )}

        {children}
        <div className="w-100 d-flex flex-row justify-content-end mt-4 pr-2">
          {cancelText !== '' && (
            <Button
              className="text-uppercase mr-3"
              type="button"
              color="secondary"
              label={cancelText}
              onClick={onCancel}
              disabled={isLoading}
            />
          )}
          {!isLoading ? (
            <Button
              className="text-uppercase"
              type="button"
              color="primary"
              label={okText}
              onClick={onOk}
            />
          ) : (
            <Spinner color={mainColor} />
          )}
        </div>
      </ModalBody>
    </ConfirmModalWrapper>
  );
};

ConfirmModal.defaultProps = {
  isOpen: false,
  toggle: () => false,
  className: '',
  cancelText: '',
  onCancel: () => null,
  children: undefined,
  confirmMessage: '',
  confirmMessages: [],
  isLoading: false,
};

ConfirmModal.propTypes = {
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  confirmMessage: PropTypes.string,
  confirmMessages: PropTypes.arrayOf([]),
  cancelText: PropTypes.string,
  okText: PropTypes.string.isRequired,
  onCancel: PropTypes.func,
  onOk: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  children: PropTypes.element,
};

export default ConfirmModal;
